"use client";

import React from "react";

import { GeneralInformation } from "@/payload-types";
import { CMSLink } from "../../../components/CMSLink";
import { barlow } from "@/utilities/fontImport";
import { Media } from "../../Media/Media";
import { ConnectionMenu } from "./ConnectionMenu";
import { Logo } from "../Logo";
import { LanguagePicker } from "../LanguagePicker";
import { NavLink } from "../HeaderClient";

export const HeaderDesktop = ({
  data,
  links,
}: {
  data: GeneralInformation;
  links: NavLink[];
}) => {
  const { navigationItems, logo } = data || [];

  const navigationLeft = navigationItems?.filter(
    (navItem) => navItem.linkLocation === "left",
  );
  const navigationRight = navigationItems?.filter(
    (navItem) => navItem.linkLocation === "right",
  );

  return (
    <div className={`${barlow.className}`}>
      <nav
        id="nav-bar"
        className="
          fixed top-0 left-0 w-full z-50
          lg:flex lg:flex-row
          justify-between items-center
          py-2.5
          text-xl lg:gap-4
          hidden
          shadow text-white
          bg-linear-to-b from-[#2A2D3F] via-[#0A0A0E] to-[#000000]
          text-nowrap
        "
      >
        <div className="flex items-center lg:px-32 w-full">
          <div className="flex items-center gap-8 w-full">
            {logo && <Logo logo={logo} className="flex items-center" />}
            <div className="flex items-center justify-between w-full">
              <div className="flex justify-between items-center gap-7">
                {navigationItems &&
                  navigationLeft &&
                  navigationLeft.map((navItem) => {
                    if (!navItem.linkWithMedia) return null;

                    return (
                      <div key={navItem.id} className="flex items-center">
                        {navItem.linkWithMedia.media && (
                          <Media
                            resource={navItem.linkWithMedia.media}
                            imgClassName="w-7 mr-2 shrink-0"
                          />
                        )}
                        <CMSLink
                          {...navItem.linkWithMedia}
                          className="text-xl"
                        />
                      </div>
                    );
                  })}
              </div>
              <div className="flex justify-between items-center gap-7">
                {navigationItems &&
                  navigationRight &&
                  navigationRight.map((navItem) => {
                    if (!navItem.linkWithMedia) return null;

                    return (
                      <div key={navItem.id} className="flex items-center">
                        {navItem.linkWithMedia.media && (
                          <Media
                            resource={navItem.linkWithMedia.media}
                            imgClassName="w-7 mr-2 shrink-0"
                          />
                        )}
                        <CMSLink
                          {...navItem.linkWithMedia}
                          className="text-xl"
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          <LanguagePicker className="relative -mr-4 ml-8" />
          <ConnectionMenu links={links} />
        </div>
      </nav>
      <div className="h-0 lg:h-[52px]" aria-hidden="true" />
    </div>
  );
};
